"use strict";

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var a = 0, r = new Array(t); a < t; a++) r[a] = e[a];
  return r;
}
function _iterableToArrayLimit(e, t) {
  var a = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (null != a) {
    var r,
      n,
      o = [],
      i = !0,
      l = !1;
    try {
      for (a = a.call(e); !(i = (r = a.next()).done) && (o.push(r.value), !t || o.length !== t); i = !0);
    } catch (e) {
      l = !0, n = e;
    } finally {
      try {
        i || null == a.return || a.return();
      } finally {
        if (l) throw n;
      }
    }
    return o;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var r = t[a];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}
var BackendService = require("./../Backend.service"),
  CriticalInput = require("./../CriticalInput.service"),
  MASTER_MAPPER = {
    BUBBLE: {
      attributes: {
        firstName: "firstName",
        middleName: "middleName",
        lastName: "lastName",
        addressType: "addressType",
        address: "address",
        city: "city",
        affiliateCode: "affiliateCode",
        arcId: "arcId",
        benefitLength: "benefitLength",
        browserName: "browserName",
        browserVersion: "browserVersion",
        campaignCode: "campaignCode",
        channel: "channel",
        cookieId: "cookieId",
        coverage: "coverage",
        premiumFrequency: "premiumFrequency",
        deviceId: "deviceId",
        deviceType: "deviceType",
        distributorId: "distributorId",
        dob: "dob",
        gender: "gender",
        healthStatusRank: "healthStatusRank",
        height: "height",
        ipAddress: "ipAddress",
        productId: "productId",
        quoteRateClassRequest: "quoteRateClassRequest",
        referenceURL: "referenceURL",
        state: "state",
        term: "term",
        tobaccoUse: "tobaccoUse",
        riskClass: "riskClass",
        weight: "weight",
        zip: "zip"
      },
      values: {
        lastName: {
          format: "string",
          formatType: "Extended",
          example: "Shetty"
        },
        firstName: {
          format: "string",
          formatType: "Extended",
          example: "Sanath"
        },
        middleName: {
          format: "string",
          formatType: "Extended",
          example: "NA"
        },
        addressType: {
          format: "string",
          formatType: "Extended",
          example: "PhysicalRisk"
        },
        address: {
          format: "string",
          formatType: "Extended",
          example: "4529 winona"
        },
        city: {
          format: "string",
          formatType: "Extended",
          example: "Denver"
        },
        affiliateCode: {
          format: "string",
          formatType: "Extended",
          example: "Shetty"
        },
        arcId: {
          format: "string",
          formatType: "Extended",
          example: "Sanath"
        },
        benefitLength: {
          format: "string",
          formatType: "Extended",
          example: "NA"
        },
        browserName: {
          format: "string",
          formatType: "Extended",
          example: "PhysicalRisk"
        },
        browserVersion: {
          format: "string",
          formatType: "Extended",
          example: "4529 winona"
        },
        campaignCode: {
          format: "string",
          formatType: "Extended",
          example: "Denver"
        },
        channel: {
          format: "string",
          formatType: "number",
          example: "colorado"
        },
        cookieId: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        },
        coverage: {
          format: "number",
          example: 5e5
        },
        premiumFrequency: {
          format: "string",
          example: "m"
        },
        deviceId: {
          format: "yyyy",
          formatType: "Date",
          example: "1990"
        },
        deviceType: {
          format: "string",
          example: "CA"
        },
        distributorId: {
          format: "number",
          example: 1
        },
        dob: {
          format: "number",
          example: 1
        },
        gender: {
          format: "number",
          example: 1
        },
        healthStatusRank: {
          format: "number",
          example: 1
        },
        height: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        },
        ipAddress: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        },
        productId: {
          format: "number",
          example: 5e5
        },
        quoteRateClassRequest: {
          format: "number",
          example: 5e5
        },
        referenceURL: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        },
        state: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        },
        term: {
          format: "number",
          example: 5e5
        },
        tobaccoUse: {
          format: "number",
          example: 5e5
        },
        riskClass: {
          format: "string",
          formatType: "Extended-text",
          example: "Super Preferred Non-Tobacco"
        },
        weight: {
          format: "number",
          example: 5e5
        },
        zip: {
          format: "string",
          formatType: "Array-Extended",
          example: "80212"
        }
      }
    },
    stillWater: {
      attributes: {
        lastName: "Surname",
        firstName: "GivenName",
        middleName: "OtherGivenName",
        addressType: "AddrTypeCd",
        address: "Addr1",
        city: "City",
        state: "StateProvCd",
        zip: "PostalCode",
        coverage: "coverage"
      },
      values: {
        Surname: {
          format: "string",
          formatType: "Extended",
          example: "Shetty"
        },
        GivenName: {
          format: "string",
          formatType: "Extended",
          example: "Sanath"
        },
        OtherGivenName: {
          format: "string",
          formatType: "Extended",
          example: "NA"
        },
        AddrTypeCd: {
          format: "string",
          formatType: "Extended",
          example: "PhysicalRisk"
        },
        Addr1: {
          format: "string",
          formatType: "Extended",
          example: "4529 winona"
        },
        City: {
          format: "string",
          formatType: "Extended",
          example: "Denver"
        },
        StateProvCd: {
          format: "string",
          formatType: "string",
          example: "colorado"
        },
        PostalCode: {
          format: "string",
          formatType: "string",
          example: "80212"
        },
        coverage: {
          format: "number",
          formatType: "Extended",
          example: 10
        }
      }
    },
    symetra: {
      attributes: {
        productId: "product",
        term: "term",
        dob: "age",
        coverage: "faceAmount",
        gender: "gender",
        tobaccoUse: "rateClass"
      },
      values: {
        product: {
          format: "string",
          formatType: "Extended-prod",
          example: "swiftterm"
        },
        term: {
          format: "number",
          formatType: "Extended",
          example: 10
        },
        age: {
          format: "number",
          formatType: "Extended-date",
          example: 10
        },
        faceAmount: {
          format: "number",
          formatType: "Extended",
          example: 10
        },
        gender: {
          format: "string",
          formatType: "Extended-string",
          example: "Never"
        },
        rateClass: {
          format: "string",
          formatType: "Extended-text",
          example: "swiftterm"
        }
      }
    },
    paclife: {
      attributes: {
        coverage: "faceAmount",
        dob: "dob",
        riskClass: "riskClass",
        premiumFrequency: "premiumFrequency",
        state: "state",
        gender: "gender",
        productId: "productCode",
        tobaccoUse: "smoker"
      },
      values: {
        faceAmount: {
          format: "number",
          formatType: "Extended",
          example: 10
        },
        dob: {
          format: "yyyy-mm-dd",
          formatType: "Date",
          example: "1990-05-11"
        },
        riskClass: {
          format: "string",
          formatType: "Extended-text",
          example: "Super Preferred Non-Tobacco"
        },
        premiumFrequency: {
          format: "string",
          formatType: "Extended",
          example: "m"
        },
        state: {
          format: "string",
          formatType: "string",
          example: "colorado"
        },
        gender: {
          format: "string",
          formatType: "Extended-string",
          example: "Male"
        },
        productCode: {
          format: "string",
          formatType: "Extended",
          example: "swiftterm"
        },
        smoker: {
          format: "bool",
          formatType: "Extended",
          example: !1
        }
      }
    },
    SBLI: {
      attributes: {
        gender: "gender",
        dob: "dob",
        term: "term",
        zip: "zip",
        state: "state",
        height: "height",
        weight: "weight",
        tobaccoUse: "tobaccoUse",
        coverage: "coverage"
      },
      values: {
        gender: {
          format: "string",
          formatType: "Extended",
          example: "M"
        },
        dob: {
          format: "mm/dd/yyyy",
          formatType: "Date",
          example: "08/30/2002"
        },
        term: {
          format: "number",
          formatType: "Extended",
          example: 1
        },
        zip: {
          format: "string",
          formatType: "string",
          example: "80212"
        },
        state: {
          format: "string",
          formatType: "Extended",
          example: "CA"
        },
        height: {
          format: "string",
          formatType: "Extended",
          example: "5.06"
        },
        weight: {
          format: "number",
          formatType: "number",
          example: 5e5
        },
        tobaccoUse: {
          format: "number",
          formatType: "Extended",
          example: 1
        },
        coverage: {
          format: "number",
          formatType: "Extended",
          example: 10
        }
      }
    }
  },
  Mapper = function () {
    return _createClass(function e() {
      _classCallCheck(this, e);
    }, [{
      key: "mapdata",
      value: function (e, t, a) {
        this.uniqueId = e;
        var r = this.getInput(a);
        return this.mapTo(t, r);
      }
    }, {
      key: "mapTo",
      value: function (e, t) {
        var a, r, n;
        switch (e) {
          case "stillWater":
            return a = MASTER_MAPPER[e].attributes, r = MASTER_MAPPER[e].values, n = MASTER_MAPPER.BUBBLE.values, this.mapValueUsingAttributesstillWater(e, a, r, n, t);
          case "symetra":
            return a = MASTER_MAPPER[e].attributes, r = MASTER_MAPPER[e].values, n = MASTER_MAPPER.BUBBLE.values, this.mapValueUsingAttributesSymetra(e, a, r, n, t);
          case "paclife":
            return a = MASTER_MAPPER[e].attributes, r = MASTER_MAPPER[e].values, n = MASTER_MAPPER.BUBBLE.values, this.mapValueUsingAttributespaclife(e, a, r, n, t);
          case "SBLI":
            return a = MASTER_MAPPER[e].attributes, r = MASTER_MAPPER[e].values, n = MASTER_MAPPER.BUBBLE.values, this.mapValueUsingAttributesSBLI(e, a, r, n, t);
        }
      }
    }, {
      key: "mapValueUsingAttributesstillWater",
      value: function (e, t, a, r, n) {
        var o,
          i,
          l,
          s,
          c = this,
          d = {};
        Object.entries(n).forEach(function (e) {
          var n = _slicedToArray(e, 2),
            o = n[0],
            i = n[1],
            l = t[o];
          if (null != l) {
            var s = a[l],
              m = c.getFormattedDatastillWater(s.format, r[o].format, s.formatType, i);
            d[l] = m;
          }
        });
        var m = "";
        null != n && null !== (o = n.propertyDetails) && void 0 !== o && o.home_type && "CD" != (null == n || null === (i = n.propertyDetails) || void 0 === i ? void 0 : i.home_type) && (m = "<Deductible>\n            <FormatInteger>DEDUCTIBLE_PLACEHOLDER</FormatInteger>\n            <DeductibleAppliesToCd>AllPeril</DeductibleAppliesToCd>\n         </Deductible>");
        var u = "";
        return null != n && null !== (l = n.propertyDetails) && void 0 !== l && l.home_type && "CD" == (null == n || null === (s = n.propertyDetails) || void 0 === s ? void 0 : s.home_type) && "" != n.unitNo && (u = "<Addr2>".concat(n.unitNo, "</Addr2>")), '<ACORD xmlns="http://www.ACORD.org/standards/PC_Surety/ACORD1/xml/Stillwater">\n          SIGNONREQ_PLACEHOLDER\n         <InsuranceSvcRq>\n            \x3c!-- The following field is required to be unique for every service request,\n            format is 8-4-4-4-12 hexadecimal. If 00000000-0000-0000-0000-000000000000\n            is used, then we will generate a RqUID for you. --\x3e\n            <RqUID>RQUID_PLACEHOLDER</RqUID>\n            <HomePolicyQuoteInqRq>\n               \x3c!-- Use the same value as the RqUID above --\x3e\n               <RqUID>RQUID_PLACEHOLDER</RqUID>\n               \x3c!-- now --\x3e\n               <TransactionRequestDt>2014-01-15T09:30:20</TransactionRequestDt>\n               <CurCd>USD</CurCd>\n               <InsuredOrPrincipal>\n                  <GeneralPartyInfo>\n                     <NameInfo>\n                        <PersonName>\n                           <Surname>'.concat(d.Surname, "</Surname>\n                           <GivenName>").concat(d.GivenName, "</GivenName>\n                           \x3c!--<OtherGivenName>").concat(d.OtherGivenName, "</OtherGivenName>--\x3e\n                        </PersonName>\n                        TAX_PLACEHOLDER\n                     </NameInfo>\n                     <Addr>\n                        <AddrTypeCd>MailingAddress</AddrTypeCd>\n                        <Addr1>").concat(d.Addr1, "</Addr1>\n                        ").concat(u, "\n                        <City>").concat(d.City, "</City>\n                        <StateProvCd>").concat(d.StateProvCd, "</StateProvCd>\n                        <PostalCode>").concat(d.PostalCode, '</PostalCode>\n                     </Addr>\n                     PREVADDRESS_PLACEHOLDER\n                     COMMUNICATION_PLACEHOLDER\n                  </GeneralPartyInfo>\n                  <InsuredOrPrincipalInfo>\n                     <InsuredOrPrincipalRoleCd>FNI</InsuredOrPrincipalRoleCd>\n                     BIRTHDATE_PLACEHOLDER\n                     MARITALSTATUS_PLACEHOLDER\n                  </InsuredOrPrincipalInfo>\n               </InsuredOrPrincipal>\n               SPOUSEDETAILS_PLACEHOLDER\n               <PersPolicy>\n                  <LOBCd>HOME</LOBCd>\n                  EFFECTIVEDATE_PLACEHOLDER\n                  LOSS_PLACEHOLDER\n                  OTHERPOLICY_PLACEHOLDER\n                  POLICYNUMBER_PLACEHOLDER\n                  <PersApplicationInfo>\n                     <InsuredOrPrincipal />\n                     <ResidenceOwnedRentedCd>OWNED</ResidenceOwnedRentedCd>\n                  </PersApplicationInfo>\n               </PersPolicy>\n               <Location id="LOC1">\n                  <ItemIdInfo />\n                  <Addr>\n                     <AddrTypeCd>').concat(d.AddrTypeCd, "</AddrTypeCd>\n                     <Addr1>").concat(d.Addr1, "</Addr1>\n                     ").concat(u, "\n                     <City>").concat(d.City, "</City>\n                     <StateProvCd>").concat(d.StateProvCd, "</StateProvCd>\n                     <PostalCode>").concat(d.PostalCode, '</PostalCode>\n                  </Addr>\n               </Location>\n               <HomeLineBusiness>\n                  <LOBCd>HOME</LOBCd>\n                  <Dwell id="DWE1" LocationRef="LOC1">\n                     <PolicyTypeCd>POLICYTYPE_PLACEHOLDER</PolicyTypeCd>\n                     PURCHASEYEAR_PLACEHOLDER\n                     CONSTRUCTION_PLACEHOLDER\n                     <DwellOccupancy>\n                        YEAROCCUPANCY_PLACEHOLDER\n                        <ResidenceTypeCd>RESIDENCETYPE_PLACEHOLDER</ResidenceTypeCd>\n                        <DwellUseCd>1</DwellUseCd>\n                        <OccupancyTypeCd>OWNER</OccupancyTypeCd>\n                     </DwellOccupancy>\n                     BLDGPROTECTION_PLACEHOLDER\n                     BLDGIMPROVEMENTS_PLACEHOLDER\n                     DWELLINSPECTIONVALUATION_PLACEHOLDER\n                     <Coverage>\n                        <CoverageCd>DWELL</CoverageCd>\n                        <Limit>\n                           <FormatInteger>').concat(d.coverage, "</FormatInteger>\n                        </Limit>\n                        ").concat(m, "\n                        WINDHAIL_PLACEHOLDER\n                        HURRICANE_PLACEHOLDER\n                     </Coverage>\n                     COVERAGES_PLACEHOLDER\n                     OCEAN_PLACEHOLDER\n                  </Dwell>\n                  SPP_PLACEHOLDER\n               </HomeLineBusiness>\n            </HomePolicyQuoteInqRq>\n         </InsuranceSvcRq>\n        </ACORD>");
      }
    }, {
      key: "mapValueUsingAttributesSymetra",
      value: function (e, t, a, r, n) {
        var o = this,
          i = {};
        Object.entries(n).forEach(function (e) {
          var n = _slicedToArray(e, 2),
            l = n[0],
            s = n[1],
            c = t[l];
          if (null != c) {
            var d = a[c],
              m = o.getFormattedDataSymetra(d.format, r[l].format, d.formatType, s);
            i[c] = m;
          }
        });
        var l = i;
        return console.log("outputJson for " + e + " : ", l), l;
      }
    }, {
      key: "mapValueUsingAttributespaclife",
      value: function (e, t, a, r, n) {
        var o = this,
          i = {};
        Object.entries(n).forEach(function (e) {
          var n = _slicedToArray(e, 2),
            l = n[0],
            s = n[1],
            c = t[l];
          if (null != c) {
            var d = a[c],
              m = o.getFormattedDatapaclife(d.format, r[l].format, d.formatType, s);
            i[c] = m;
          }
        });
        var l = i;
        return l.productCode = "FT6518", console.log("outputJson for " + e + " : ", l), l;
      }
    }, {
      key: "mapValueUsingAttributesSBLI",
      value: function (e, t, a, r, n) {
        var o = this,
          i = {};
        Object.entries(n).forEach(function (e) {
          var n = _slicedToArray(e, 2),
            l = n[0],
            s = n[1],
            c = t[l];
          if (null != c) {
            var d = a[c],
              m = o.getFormattedDataSBLI(d.format, r[l].format, d.formatType, s);
            i[c] = m;
          }
        });
        var l = i;
        return l.arcId = null, l.quoteRateClassRequest = 10, l.distributorId = 8444, l.productId = "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? 81410 : 8141, l.healthStatusRank = 1, l.benefitLength = 1, l.referenceURL = "htpp://www.affigee.com", l.channel = "commercial", l.campaignCode = 1, l.affiliateCode = 1, l.deviceId = "Id12345", l.deviceType = "laptop", l.cookieId = 1, l.browserVersion = 77, l.browserName = "chrome", l.ipAddress = "123.23.2.232", console.log("outputJson for " + e + " : ", l), l;
      }
    }, {
      key: "getFormattedDatastillWater",
      value: function (e, t, a, r) {
        var n;
        switch (a) {
          case "Date":
            n = this.convertDate(e, t, r);
            break;
          case "string":
            switch (e) {
              case "string":
                n = r.toString();
            }
            break;
          case "number":
            switch (e) {
              case "ARRAY":
                n = [r];
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended":
            switch (e) {
              case "string":
                n = r.toString();
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Array-Extended":
            n = [r + " Year Term"];
            break;
          default:
            r.toString();
        }
        return n;
      }
    }, {
      key: "getFormattedDataSymetra",
      value: function (e, t, a, r) {
        var n;
        switch (a) {
          case "Date":
            n = this.convertDate(e, t, r);
            break;
          case "string":
            switch (e) {
              case "string":
                n = r.toString();
            }
            break;
          case "number":
            switch (e) {
              case "ARRAY":
                n = [r];
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended":
            switch (e) {
              case "string":
                n = r.toString();
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended-string":
            switch (e) {
              case "string":
                n = "F" === r ? "Female" : "Male";
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended-date":
            switch (e) {
              case "number":
                var o = new Date(r).getFullYear();
                n = new Date().getFullYear() - o;
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-text":
            switch (e) {
              case "string":
                n = "1" === r ? "B - Super Preferred Nicotine" : "S - Standard Nicotine";
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-prod":
            switch (e) {
              case "string":
                n = "81410" === r ? "swiftterm" : "NA";
                break;
              default:
                r.toString();
            }
            break;
          case "Array-Extended":
            n = [r + " Year Term"];
            break;
          default:
            r.toString();
        }
        return n;
      }
    }, {
      key: "getFormattedDatapaclife",
      value: function (e, t, a, r) {
        var n;
        switch (a) {
          case "Date":
            n = this.convertDate(e, t, r);
            break;
          case "string":
            switch (e) {
              case "string":
                n = r.toString();
            }
            break;
          case "number":
            switch (e) {
              case "ARRAY":
                n = [r];
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended":
            switch (e) {
              case "string":
                n = r.toString();
                break;
              case "number":
                n = parseInt(r);
                break;
              case "bool":
                n = 1 === r;
            }
            break;
          case "Extended-string":
            switch (e) {
              case "string":
                n = "F" === r ? "Female" : "Male";
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended-date":
            switch (e) {
              case "number":
                var o = new Date(r).getFullYear();
                n = new Date().getFullYear() - o;
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-text":
            switch (e) {
              case "string":
                n = r.toString();
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-prod":
            switch (e) {
              case "string":
                n = "81410" === r ? "swiftterm" : "NA";
                break;
              default:
                r.toString();
            }
            break;
          case "Array-Extended":
            n = [r + " Year Term"];
            break;
          default:
            r.toString();
        }
        return n;
      }
    }, {
      key: "getFormattedDataSBLI",
      value: function (e, t, a, r) {
        var n;
        switch (a) {
          case "Date":
            n = this.convertDate(e, t, r);
            break;
          case "string":
            switch (e) {
              case "string":
                n = r.toString();
            }
            break;
          case "number":
            switch (e) {
              case "ARRAY":
                n = [r];
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended":
            switch (e) {
              case "string":
                n = r.toString();
                break;
              case "number":
                n = parseInt(r);
                break;
              case "bool":
                n = 1 === r;
            }
            break;
          case "Extended-string":
            switch (e) {
              case "string":
                n = "F" === r ? "Female" : "Male";
                break;
              case "number":
                n = parseInt(r);
            }
            break;
          case "Extended-date":
            switch (e) {
              case "number":
                var o = new Date(r).getFullYear();
                n = new Date().getFullYear() - o;
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-text":
            switch (e) {
              case "string":
                n = 1 === r ? "Super Preferred Non-Tobacco" : "NA";
                break;
              default:
                r.toString();
            }
            break;
          case "Extended-prod":
            switch (e) {
              case "string":
                n = "81410" === r ? "swiftterm" : "NA";
                break;
              default:
                r.toString();
            }
            break;
          case "Array-Extended":
            n = [r + " Year Term"];
            break;
          default:
            r.toString();
        }
        return n;
      }
    }, {
      key: "convertDate",
      value: function (e, t, a) {
        var r,
          n = new Date(a),
          o = n.getDate(),
          i = n.getMonth() + 1,
          l = n.getFullYear();
        return "yyyy" === t && (l = a, o = 1, i = 1), o < 10 && (o = "0" + o), i < 10 && (i = "0" + i), "yyyy-mm-dd" == e ? r = n = l + "-" + i + "-" + o : "yyyy/mm/dd" == e ? r = n = l + "/" + i + "/" + o : "dd-mm-yyyy" == e ? r = n = o + "-" + i + "-" + l : "dd/mm/yyyy" == e ? r = n = o + "/" + i + "/" + l : "mm-dd-yyyy" == e ? r = n = i + "-" + o + "-" + l : "mm/dd/yyyy" == e && (r = n = i + "/" + o + "/" + l), r;
      }
    }, {
      key: "getInput",
      value: function (e) {
        return this.getInputjson(e);
      }
    }, {
      key: "getInputjson",
      value: function (e) {
        var t, a, r, n, o, i, l, s, c;
        return {
          arcId: null,
          quoteRateClassRequest: 10,
          distributorId: 8444,
          productId: "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? 81410 : 8141,
          firstName: e.firstName,
          middleName: e.middleName,
          lastName: e.lastName,
          addressType: e.addressType,
          address: e.address,
          gender: e.gender,
          dob: e.dob,
          term: e.term,
          zip: e.zip,
          city: e.city,
          state: e.state,
          height: e.height,
          weight: e.weight,
          healthStatusRank: 1,
          tobaccoUse: e.tobaccoUse,
          riskClass: e.riskClass,
          coverage: e.coverage,
          premiumFrequency: e.premiumFrequency,
          benefitLength: 1,
          referenceURL: "htpp://www.affigee.com",
          channel: "commercial",
          campaignCode: 1,
          affiliateCode: 1,
          deviceId: "Id12345",
          deviceType: "laptop",
          cookieId: 1,
          browserVersion: 77,
          browserName: "chrome",
          ipAddress: "123.23.2.232",
          unitNo: e.unitNo,
          propertyDetails: {
            stories: (null === (t = e.propertyDetails) || void 0 === t ? void 0 : t.stories) || "",
            construction_type: (null === (a = e.propertyDetails) || void 0 === a ? void 0 : a.construction_type) || "",
            year_built: (null === (r = e.propertyDetails) || void 0 === r ? void 0 : r.year_built) || "",
            living_size: (null === (n = e.propertyDetails) || void 0 === n ? void 0 : n.living_size) || "",
            roof_type: (null === (o = e.propertyDetails) || void 0 === o ? void 0 : o.roof_type) || "",
            swimming_pool: (null === (i = e.propertyDetails) || void 0 === i ? void 0 : i.swimming_pool) || "",
            roof_constructed: (null === (l = e.propertyDetails) || void 0 === l ? void 0 : l.roof_constructed) || "",
            home_type: (null === (s = e.propertyDetails) || void 0 === s ? void 0 : s.home_type) || "",
            purchase_date: (null === (c = e.propertyDetails) || void 0 === c ? void 0 : c.purchase_date) || ""
          }
        };
      }
    }, {
      key: "getAnswerJson2",
      value: function (e, t) {
        var a = {};
        switch (e) {
          case "paclife":
            a = {
              quote: {
                mapTo: "quote",
                callBack: null,
                formatType: "default"
              },
              policyOwner: {
                mapTo: {
                  classification: {
                    mapTo: "classification",
                    callBack: null,
                    formatType: "default"
                  },
                  relationship: {
                    mapTo: "policyOwner.relationship",
                    callback: null,
                    formatType: "string"
                  },
                  individualName: {
                    mapTo: {
                      firstName: {
                        mapTo: "policyOwner.firstname",
                        callBack: null,
                        formatType: "string"
                      },
                      lastName: {
                        mapTo: "policyOwner.lastname",
                        callBack: null,
                        formatType: "string"
                      }
                    },
                    callBack: null,
                    formatType: "json"
                  },
                  dob: {
                    mapTo: "policyOwner.dob",
                    callBack: null,
                    formatType: "string"
                  },
                  address: {
                    mapTo: "policyOwner.address",
                    callBack: null,
                    formatType: "default"
                  },
                  email: {
                    mapTo: "policyOwner.email",
                    callBack: null,
                    formatType: "default"
                  },
                  phone: {
                    mapTo: "policyOwner.phone",
                    callBack: null,
                    formatType: "default"
                  },
                  ss: {
                    mapTo: "policyOwner.ssn",
                    callback: null,
                    formatType: "default"
                  }
                },
                callback: null,
                formatType: "json"
              },
              insured: {
                mapTo: {
                  name: {
                    mapTo: {
                      firstName: {
                        mapTo: "firstname",
                        callback: null,
                        formatType: "default"
                      },
                      lastName: {
                        mapTo: "lastname",
                        callback: null,
                        formatType: "default"
                      }
                    },
                    callback: null,
                    formatType: "json"
                  },
                  dob: {
                    mapTo: "dob",
                    callback: null,
                    formatType: "default"
                  },
                  address: {
                    mapTo: "address",
                    callback: null,
                    formatType: "default"
                  },
                  email: {
                    mapTo: "email",
                    callback: null,
                    formatType: "default"
                  },
                  phone: {
                    mapTo: "phone",
                    callback: null,
                    formatType: "default"
                  },
                  ss: {
                    mapTo: "isDependent.ssn",
                    callback: null,
                    formatType: "default"
                  },
                  activeMilitary: {
                    mapTo: "isActiveMilitary",
                    callback: null,
                    formatType: "default"
                  },
                  usStateOfBirth: {
                    mapTo: "countryBorn.state",
                    callback: null,
                    formatType: "default"
                  },
                  countryOfBirth: {
                    mapTo: "countryBorn.country",
                    callback: null,
                    formatType: "default"
                  },
                  isDependent: {
                    mapTo: "isDependent.dependent",
                    callback: null,
                    formatType: "default"
                  },
                  existingLifeInsurance: {
                    mapTo: "existingLifeInsurance",
                    callback: null,
                    formatType: "default"
                  },
                  pendingOrPlanToBuyAdditional: {
                    mapTo: "pendingOrPlanToBuyAdditional",
                    callback: null,
                    formatType: "default"
                  }
                },
                callback: null,
                formatType: "json"
              },
              primaryBeneficiaries: {
                mapTo: ["addBeneficiaries", {
                  classification: {
                    mapTo: "classification",
                    callback: null,
                    formatType: "default"
                  },
                  relationship: {
                    mapTo: "relationship",
                    callback: null,
                    formatType: "default"
                  },
                  individualName: {
                    mapTo: {
                      firstName: {
                        mapTo: "firstname",
                        callback: null,
                        formatType: "default"
                      },
                      lastName: {
                        mapTo: "lastname",
                        callback: null,
                        formatType: "default"
                      }
                    },
                    callback: null,
                    formatType: "json"
                  },
                  dob: {
                    mapTo: "dateofbirth",
                    callback: null,
                    formatType: "default"
                  },
                  percentage: {
                    mapTo: "percentage",
                    callback: null,
                    formatType: "default"
                  }
                }],
                callback: null,
                formatType: "array_of_json"
              },
              purposeOfInsurance: {
                mapTo: "insurancePurpose",
                callback: null,
                formatType: "default"
              },
              product: {
                mapTo: "product",
                callback: null,
                formatType: "default"
              },
              agent: {
                mapTo: "agent",
                callback: null,
                formatType: "default"
              }
            };
        }
        return this.formatOutputJson(t, a);
      }
    }, {
      key: "formatOutputJson",
      value: function (e, t) {
        for (var a = {}, r = {}, n = ["json", "array_of_json", "default"], o = "", i = 0, l = Object.entries(t); i < l.length; i++) {
          var s = _slicedToArray(l[i], 2),
            c = s[0],
            d = s[1];
          if (r = e, "string" == typeof d.mapTo && (o = d.mapTo).includes(".")) {
            o = o.split(".");
            for (var m = 0; m < o.length - 1; m++) r = r[o[m]];
            o = [o[o.length - 1]], d.mapTo = o;
          }
          if (n.includes(d.formatType) || (null != d.callBack ? a[c] = d.callBack(d.callBackInput[0], d.callBackInput[1]) : a[c] = r[d.mapTo]), "default" == d.formatType && (a[c] = r[d.mapTo]), "json" == d.formatType && (a[c] = this.formatOutputJson(r, d.mapTo)), "array_of_json" == d.formatType) {
            a[c] = [];
            for (var u = 0; u < r[d.mapTo[0]].length; u++) a[c].push(this.formatOutputJson(r[d.mapTo[0]][u], d.mapTo[1]));
          }
        }
        return a;
      }
    }, {
      key: "getFormattedDate",
      value: function (e, t) {
        return "Some Date";
      }
    }, {
      key: "getArrayOfJson",
      value: function (e, t) {
        return [];
      }
    }, {
      key: "getGenderString",
      value: function (e) {
        return e ? "Male" : "Female";
      }
    }, {
      key: "getAgeFromDob",
      value: function (e) {
        return 37;
      }
    }, {
      key: "getSWCoverageXML",
      value: function (e) {
        var t = "<Coverage>";
        return t += "<CoverageCd>".concat(e.cdText, "</CoverageCd>"), e.limit && "" != e.limit && (t += "<Limit>", "integer" == e.limitFormatType ? t += "<FormatInteger>".concat(e.limit, "</FormatInteger>") : t += "<FormatPct>".concat(e.limit, "</FormatPct>"), t += "</Limit>"), e.deductibleFormatType && "" != e.deductibleFormatType && (t += "<Deductible>", "integer" == e.deductibleFormatType ? t += "<FormatInteger>".concat(e.decuctible, "</FormatInteger>") : t += "<FormatPct>".concat(e.decuctible, "</FormatPct>"), e.deductibleApplies && "" != e.deductibleApplies && (t += "<DeductibleAppliesToCd>".concat(e.deductibleApplies, "</DeductibleAppliesToCd>")), t += "</Deductible>"), t += "</Coverage>";
      }
    }, {
      key: "getSWQuestionXML",
      value: function (e) {
        return "<QuestionAnswer>\n                                <QuestionCd>".concat(e.question, "</QuestionCd>\n                                <YesNoCd>").concat(e.answer, "</YesNoCd>\n                            </QuestionAnswer>");
      }
    }, {
      key: "getSppMap",
      value: function () {
        return {
          71: "JL",
          91: "FR",
          141: "GF",
          144: "SV",
          190: "CM",
          "335A": "None",
          "336A": "None",
          450: "MI",
          142: "GU",
          143: "com.stillwater_GUNFRD"
        };
      }
    }, {
      key: "getSWSPPXML",
      value: function (e) {
        var t = this.getSppMap();
        return "<PropertySchedule>\n                    <IsSummaryInd>0</IsSummaryInd>\n                    <ItemValueAmt>\n                        <Amt>".concat(e.amount, "</Amt>\n                    </ItemValueAmt>\n                    <PropertyClassCd>").concat(t[e.spp_id], "</PropertyClassCd>\n                    <ItemDefinition>\n                        <ItemTypeCd>ScheduledProperty</ItemTypeCd>\n                        <ItemDesc>").concat(e.desc, "</ItemDesc>\n                    </ItemDefinition>\n                </PropertySchedule>");
      }
    }, {
      key: "cleanSWXML",
      value: function (e) {
        return e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace("PREVADDRESS_PLACEHOLDER", "")).replace("COMMUNICATION_PLACEHOLDER", "")).replace("BIRTHDATE_PLACEHOLDER", "")).replace("PURCHASEYEAR_PLACEHOLDER", "")).replace("YEAROCCUPANCY_PLACEHOLDER", "")).replace("MARITALSTATUS_PLACEHOLDER", "")).replace("SPOUSEDETAILS_PLACEHOLDER", "")).replace("CONSTRUCTION_PLACEHOLDER", "")).replace("BLDGPROTECTION_PLACEHOLDER", "")).replace("BLDGIMPROVEMENTS_PLACEHOLDER", "")).replace("DWELLINSPECTIONVALUATION_PLACEHOLDER", "")).replace("COVERAGES_PLACEHOLDER", "")).replace("OCEAN_PLACEHOLDER", "")).replace("TAX_PLACEHOLDER", "")).replace("LOSS_PLACEHOLDER", "")).replace("SPP_PLACEHOLDER", "")).replace("ISPREBIND_PLACEHOLDER", "")).replace("PAYMENTOPTION_PLACEHOLDER", "")).replace("ADDITIONALINTEREST_PLACEHOLDER", "")).replace("ACKNOWLEDGEMENT_PLACEHOLDER", "")).replace("PERSAPPINFO_PLACEHOLDER", "")).replace("POLICYNUMBER_PLACEHOLDER", "")).replace("EFFECTIVEDATE_PLACEHOLDER", "")).replace("OTHERPOLICY_PLACEHOLDER", "")).replace("WINDHAIL_PLACEHOLDER", "")).replace("HURRICANE_PLACEHOLDER", "")).replace("RESIDENCETYPE_PLACEHOLDER", "")).replace("RQUID_PLACEHOLDER", "");
      }
    }, {
      key: "getSWPrebindXML",
      value: function (e, t) {
        return '<ACORD  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns="http://www.ACORD.org/standards/PC_Surety/ACORD1/xml/Stillwater">\n        SIGNONREQ_PLACEHOLDER\n        <InsuranceSvcRq>\n            <RqUID>00000000-0000-0000-0000-000000000000</RqUID>\n            <HomePolicyQuoteInqRq>\n                <RqUID>00000000-0000-0000-0000-000000000000</RqUID>\n                <TransactionRequestDt>2014-01-15T09:30:20</TransactionRequestDt>\n                <CurCd>USD</CurCd>\n                ISPREBIND_PLACEHOLDER\n                <InsuredOrPrincipal>\n                    <GeneralPartyInfo>\n                        <NameInfo>\n                            <PersonName>\n                                <Surname>'.concat(e.lastName, "</Surname>\n                                <GivenName>").concat(e.firstName, "</GivenName>\n                                \x3c!--<OtherGivenName>").concat(e.middleName, "</OtherGivenName>--\x3e\n                            </PersonName>\n                        </NameInfo>\n                    </GeneralPartyInfo>\n                    <InsuredOrPrincipalInfo>\n                        <InsuredOrPrincipalRoleCd>FNI</InsuredOrPrincipalRoleCd>\n                    </InsuredOrPrincipalInfo>\n                </InsuredOrPrincipal>\n                <PersPolicy>\n                    <LOBCd>HOME</LOBCd>\n                    PAYMENTOPTION_PLACEHOLDER\n                    <QuoteInfo>\n                        <CompanysQuoteNumber>").concat(t, '</CompanysQuoteNumber>\n                    </QuoteInfo>\n                    ADDITIONALINTEREST_PLACEHOLDER\n                    ACKNOWLEDGEMENT_PLACEHOLDER\n                    PERSAPPINFO_PLACEHOLDER\n                </PersPolicy>\n                <Location id="LOC1">\n                    <ItemIdInfo>\n                        <AgencyId>12345</AgencyId>\n                    </ItemIdInfo>\n                    <Addr>\n                        <AddrTypeCd>').concat(e.addressType, "</AddrTypeCd>\n                        <Addr1>").concat(e.address, "</Addr1>\n                        <City>").concat(e.city, "</City>\n                        <StateProvCd>").concat(e.state, "</StateProvCd>\n                        <PostalCode>").concat(e.zip, '</PostalCode>\n                    </Addr>\n                </Location>\n                <HomeLineBusiness>\n                    <LOBCd>HOME</LOBCd>\n                    <Dwell id="DWE1" />\n                </HomeLineBusiness>\n            </HomePolicyQuoteInqRq>\n        </InsuranceSvcRq>\n    </ACORD>');
      }
    }, {
      key: "getSWBindXML",
      value: function (e, t) {
        return '<ACORD xmlns="http://www.ACORD.org/standards/PC_Surety/ACORD1/xml/Stillwater">\n        SIGNONREQ_PLACEHOLDER\n        <InsuranceSvcRq>\n            <RqUID>00000000-0000-0000-0000-000000000000</RqUID>\n            <HomePolicyAddRq>\n                <RqUID>00000000-0000-0000-0000-000000000000</RqUID>\n                <TransactionRequestDt>2014-01-15T09:30:20</TransactionRequestDt>\n                <CurCd>USD</CurCd>\n                ISPREBIND_PLACEHOLDER\n                <InsuredOrPrincipal>\n                    <InsuredOrPrincipalInfo>\n                        <InsuredOrPrincipalRoleCd>FNI</InsuredOrPrincipalRoleCd>\n                    </InsuredOrPrincipalInfo>\n                </InsuredOrPrincipal>\n                <PersPolicy>\n                    <LOBCd>HOME</LOBCd>\n                    PAYMENTOPTION_PLACEHOLDER\n                    <QuoteInfo>\n                        <CompanysQuoteNumber>'.concat(t, "</CompanysQuoteNumber>\n                    </QuoteInfo>\n                    ADDITIONALINTEREST_PLACEHOLDER\n                    ACKNOWLEDGEMENT_PLACEHOLDER\n                    PERSAPPINFO_PLACEHOLDER\n                </PersPolicy>\n                <HomeLineBusiness>\n                    <LOBCd>HOME</LOBCd>\n                    <Dwell/>\n                </HomeLineBusiness>\n            </HomePolicyAddRq>\n        </InsuranceSvcRq>\n    </ACORD>");
      }
    }]);
  }();
module.exports = {
  Mapper: Mapper
};